const closeEvent = (element, success) => {
  const event = new CustomEvent('ModalEvent', {
    bubbles: true,
    cancelable: true,
    detail: {
      action: 'CLOSE',
      success
    }
  })
  element.dispatchEvent(event)
}

export { closeEvent }
